// extracted by mini-css-extract-plugin
export default {"noMore":"index_noMore_XFSCY","todayDate":"index_todayDate_-ePnf","statusBox":"index_statusBox_Rimpn","dataAll":"index_dataAll_-QLw4","dataLoading":"index_dataLoading_uncRo"};